import React from 'react';
import PropTypes from 'prop-types';
import BaseButton from './BaseButton';

const InputButton = React.forwardRef(
  (
    {
      type = 'submit',
      value = '',
      onChange = () => {},
      className,
      ...otherProps
    },
    ref,
  ) => (
    <BaseButton
      ref={ref}
      tag="input"
      className={className}
      // input-specific props
      type={type}
      value={value}
      onChange={onChange}
      // includes variant and appearance from Button
      {...otherProps}
    />
  ),
);

InputButton.propTypes = {
  type: PropTypes.oneOf(['submit', 'file']),
  value: PropTypes.string,
};

export default InputButton;
